<script setup>
// Alças nos cantos da imagem: arrastar muda a largura em px (mostra o valor).
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { resizeWidth } from './geometry';

const props = defineProps({
  px: { type: Number, required: true },
  max: { type: Number, required: true },
  align: { type: String, default: 'center' },
});
const emit = defineEmits(['resize', 'commit']);
const { t } = useI18n();
const live = ref(null);
const CORNERS = {
  'top-left': '-left-1.5 -top-1.5 cursor-nwse-resize',
  'top-right': '-right-1.5 -top-1.5 cursor-nesw-resize',
  'bottom-left': '-bottom-1.5 -left-1.5 cursor-nesw-resize',
  'bottom-right': '-bottom-1.5 -right-1.5 cursor-nwse-resize',
};

const start = (corner, event) => {
  const startX = event.clientX;
  const startPx = props.px;
  const onMove = e => {
    live.value = resizeWidth({
      startPx,
      dx: e.clientX - startX,
      corner,
      align: props.align,
      max: props.max,
    });
    emit('resize', live.value);
  };
  const onUp = () => {
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
    if (live.value) emit('commit', live.value);
    live.value = null;
  };
  window.addEventListener('pointermove', onMove);
  window.addEventListener('pointerup', onUp);
};
</script>

<template>
  <div
    class="pointer-events-none absolute inset-0 outline outline-2 outline-n-brand"
  >
    <span
      v-for="(cls, corner) in CORNERS"
      :key="corner"
      class="pointer-events-auto absolute size-3 rounded-sm border-2 border-white bg-n-brand shadow"
      :class="cls"
      @pointerdown.stop.prevent="start(corner, $event)"
    />
    <span
      class="absolute -bottom-7 left-1/2 -translate-x-1/2 rounded bg-n-slate-12 px-1.5 py-0.5 text-[10px] text-white"
      >{{ live || px }} {{ t('EMAIL_TEMPLATES.EDITOR.PROPS.UNIT_PX') }}</span
    >
  </div>
</template>
